// export { default as gcPopup } from "./gcPopup";
import gcPopup from "./gcPopup";
export default {
    install(Vue) {
        Vue.prototype.$gcComponents = gcPopup;
    }
};
